module.exports = __webpack_public_path__ + "img/banner-direction-ylfw.33e25d0b.jpg";